import { AUTOMATION_PROVIDERS, CARD_PROVIDERS, TEMPLATE_CARDS_PROVIDERS } from '@shared/constants/providers/AutomaticCardsProviders';
import Routes from '@domain/router/routes.constants';
import { PARTNERSHIPS_PERMISSIONS } from '@domain/partnerships/partnerships.constants';
import { snakeCaseToKebabCase } from '@shared/utils/strings';

const getLowerCaseProviders = providers => Object.keys(providers)
    .reduce((acc, provider) => ({
        ...acc,
        [provider.toLowerCase()]: snakeCaseToKebabCase(providers[provider]),
    }), {});

export const features = {
    marketingBoard: 'marketing-board',
    accountDashboard: 'account-dashboard',
    topKeywords: 'top-keywords',
    riskAnalysis: 'risk-analysis',
    myMood: 'my-mood',
    companyDashboard: 'company-dashboard',
    companyChat: 'company-chat',
    gaIntegration: 'ga-integration',
    insights: 'insights',
    launcher: 'launcher',
    reportIntegration: 'report-integration',
    paretoHotSpot: 'pareto-hot-spot',
    goals: 'goals',
    forecast: 'forecast',
    segments: 'segments',
    aiBidManager: 'ai-bid-manager',
    aiBudgetManager: 'ai-budget-manager',
    allAccountsMarketingBoard: 'all-accounts-marketing-board',
    companyContactManager: 'company-contact-manager',
    accountManager: 'account-manager',
    boardSharing: 'board-sharing',
    companyTagOnTasks: 'company-tag-on-tasks',
    manageMultiplesClients: 'manage-multiple-clients',
    ...PARTNERSHIPS_PERMISSIONS,
    ...getLowerCaseProviders(AUTOMATION_PROVIDERS),
    ...getLowerCaseProviders(CARD_PROVIDERS),
    ...getLowerCaseProviders(TEMPLATE_CARDS_PROVIDERS),
};

export const featuresRoutes = {
    [Routes.PARTNERSHIPS]: features.partnerships,
    [Routes.INSIGHTS]: features.insights,
};
